import { BUTTON_TYPES, COMPONENT_TYPE, INPUT_COMPONENT_TYPE, MODULE_TYPE } from '@abiglobalhealth/go-types'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import AlertIcon from '@/assets/icons/warn-alert.svg'
import { Button } from '@/components/Button'
import { Input } from '@/components/Input'
import { useButtonClick } from '@/hooks/useButtonClick'
import { useConsultationType } from '@/hooks/useConsultationType'
import { useConversationSummaryPrefill } from '@/hooks/useConversationSummaryPrefill'
import { useModule } from '@/hooks/useModule'
import { useSurveyExit } from '@/hooks/useSurveyExit'
import { useUser } from '@/hooks/useUser'
import { getEmergencyNumberTranslation } from '@/utils/emergencyNumber'

const MIN_QUESTION_LENGTH = 50

export const MentalForm = () => {
  const { t } = useTranslation()
  const { handleButtonClick } = useButtonClick()
  const { currentModule } = useModule()
  const { consultationType } = useConsultationType()
  const { handleExit } = useSurveyExit()
  const { user } = useUser()
  const { updateSummary, isFetchingSummary } = useConversationSummaryPrefill()

  const [showModal, setShowModal] = useState(false)

  if (currentModule?.type !== MODULE_TYPE.CONSULTATION_LANDING) return null

  const createConsultation = async () => {
    if (!showModal) {
      setShowModal(true)
      return
    }
    setShowModal(false)

    handleButtonClick(currentModule.buttonAction)
  }

  useEffect(() => {
    updateSummary()
  }, [updateSummary])

  return (
    <>
      <div className="flex grow flex-col gap-6" data-testid="prescription-form-container">
        <h3>{t(`general.${consultationType}.question.title`)}</h3>

        <div className="flex max-h-52 grow">
          <Input
            id="question"
            componentType={COMPONENT_TYPE.INPUT}
            tabIndex={0}
            type={INPUT_COMPONENT_TYPE.TEXTAREA}
            placeholder={isFetchingSummary ? 'loading_summary' : `general.${consultationType}.question.placeholder`}
            minLength={MIN_QUESTION_LENGTH} // Follow up doesn't require a minimum length
            required
            disabled={isFetchingSummary}
          />
        </div>

        <Button onClick={createConsultation} disabled={isFetchingSummary}>
          {t('button.continue')}
        </Button>

        <span className="text-sm">{t(`general.${consultationType}.question.hint`)}</span>
      </div>

      {showModal && (
        <div className="animate-fade-in fixed top-0 left-0 z-30 flex h-full w-full flex-col items-center justify-center bg-black/50 p-4">
          <div className="flex w-full max-w-sm flex-col gap-6 rounded-2xl bg-white p-6">
            <img src={AlertIcon} alt="Alert icon" className="mx-auto h-15 w-15" />

            <p
              className="text-center"
              dangerouslySetInnerHTML={{
                __html: getEmergencyNumberTranslation(user?.data.country!)
              }}
            />

            <div className="flex w-full flex-col items-center justify-center gap-4">
              <Button onClick={createConsultation} customClassName="rounded-full" hasShadow={false}>
                {t('button.continue')}
              </Button>
              <Button onClick={handleExit} type={BUTTON_TYPES.OUTLINED} customClassName="rounded-full border-0" hasShadow={false}>
                {t('button.cancel_case')}
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
